// extracted by mini-css-extract-plugin
export default {"s_limited_text":"text_s_limited_text__iKyV2"};